import "../css/style.scss"
import "./modules/ctrlnavbar"
import "./modules/mobile"

// Our modules / classes
//import MobileMenu from "./modules/MobileMenu"
import Search from "./modules/search"

jQuery(document).ready(function ($) {
    $('#filtre-articles').change(function () {
        var url = $(this).val()
        window.location = url
    });    
});

// Instantiate a new object using our modules/classes
//const mobileMenu = new MobileMenu()
const search = new Search()
//

